import React from 'react';
import { Container } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';

const DPA = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />
    <Container className="py-5 flex-grow-1 bg-white shadow-sm my-5 rounded p-5">
      <h2 className="fw-bold">Data Processing Agreement (DPA)</h2>
      <p className="text-muted">Effective Date: 31 March 2026</p>
      <hr />

      <section className="mb-4">
        <h4>1. Scope</h4>
        <p>AcademicOS processes data only on documented instructions of the Customer.</p>
      </section>

      <section className="mb-4">
        <h4>2. Nature & Purpose</h4>
        <p>Processing includes storage, AI generation, concept extraction, and logging.</p>
      </section>

      <section className="mb-4">
        <h4>3. Categories of Data</h4>
        <ul>
          <li>User Data (name, email, role)</li>
          <li>Institutional Data</li>
          <li>Content Data</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4>4. Processor Obligations</h4>
        <p>AcademicOS ensures confidentiality, security, and lawful processing.</p>
      </section>

      <section className="mb-4">
        <h4>5. Security</h4>
        <p>Encryption, RBAC, audit logging, and incident response are implemented.</p>
      </section>

      <section className="mb-4">
        <h4>6. Data Subject Rights</h4>
        <p>AcademicOS assists in fulfilling access, correction, and deletion requests.</p>
      </section>

    </Container>
    <AppFooter />
  </div>
);
export default DPA;
